import { DGACheckboxInput } from "components/Shared/dga-checkbox-input/DGACheckboxInput";

import { VotingOption } from "../Helpers/VotingSectionHelpers";

type VotingCheckboxLabelsOptionsProps = {
  options: VotingOption[];
  selectedOptionIds: string[];
  onToggleOption: (optionId: string) => void;
  sectionId: string;
};

export const VotingCheckboxLabelsOptions = ({
  options,
  selectedOptionIds,
  onToggleOption,
  sectionId,
}: VotingCheckboxLabelsOptionsProps) => {
  if (!options.length) return null;

  const baseId = `${sectionId}-voting-labels`.replace(/ /g, "-");

  return (
    <div className="flex flex-col gap-3">
      {options.map((option) => {
        const description = option.fields?.Description?.value;
        if (!description) return null;

        const inputId = `${baseId}-${option.id}`;
        const isSelected = selectedOptionIds.includes(option.id);

        return (
          <div key={option.id} className="flex items-center gap-2 p-2">
            <DGACheckboxInput
              variant="default"
              size="sm"
              id={inputId}
              checked={isSelected}
              onChange={() => onToggleOption(option.id)}
              aria-label={description}
            />
            <label
              htmlFor={inputId}
              className="cursor-pointer text-sm text-primary-1000"
            >
              {description}
            </label>
          </div>
        );
      })}
    </div>
  );
};
